module.exports = function() {
  return new Worker("./" + "parcel-html-transpiler.72c8543a.worker.js");
};